import { IEnvironmentConfig } from "src/app/shared/interfaces/IEnvironmentConfig";

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/** @ignore */
export const environment: IEnvironmentConfig = {
  production: false,
  gatewayApi: "https://gateway-api.qa.orthofi-dev.com/graphql/",
  authenticationApi: "https://keymaster.qa.orthofi-dev.com",
  gatekeeperUrl: "https://gatekeeper.qa.orthofi-dev.com",
  portalUrl: "https://qa.orthofi-dev.com",
  patientUrl: "https://patient.qa.orthofi-dev.com",
  errorHandlerOptions: {
    authRedirectUrl: "https://login.qa.orthofi-dev.com/sign-in",
    consoleLogErrors: true,
  },
  errorLoggerOptions: {
    environment: "qa",
    dsn: "https://84c5a2dd1d094d3e99d372e31046157c@sentry.orthofi-dev.com/23",
    sendDefaultPii: false,
    debug: false,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
